<div class="d-flex flex-column" id="sidebar-nav">
  <ul class="nav flex-column mt-2">
    <li *ngIf="authHelper.hasRole(adminRole)" [class.active]="isActiveLink('tenants')" class="nav-item">
      <a (click)="navigateTo('tenants')" class="nav-link text-dark align-middle">
        <span class="material-icons-outlined">my_location</span>
        Területek
      </a>
    </li>
    <li *ngIf="authHelper.hasRole([adminRole, tenantAdminRole])" [class.active]="isActiveLink('users')" class="nav-item">
      <a (click)="navigateTo('users')" class="nav-link text-dark align-middle">
        <span class="material-icons-outlined">manage_accounts</span>
        Felhasználók
      </a>
    </li>
    <li *ngIf="authHelper.hasRole([adminRole, tenantAdminRole])" [class.active]="isActiveLink('subjects')" class="nav-item">
      <a (click)="navigateTo('subjects')" class="nav-link text-dark align-middle">
        <span class="material-icons-outlined">auto_stories</span>
        Vizsgatárgyak
      </a>
    </li>
    <li [class.active]="isActiveLink('exam-reports')" class="nav-item">
      <a (click)="navigateTo('exam-reports')" class="nav-link text-dark align-middle">
        <span class="material-icons-outlined">book</span>
        Jegyzőkönyvek
      </a>
    </li>
    <li [class.active]="isActiveLink('examiners')" class="nav-item">
      <a (click)="navigateTo('examiners')" class="nav-link text-dark">
        <span class="material-icons">people</span>
        Vizsgabiztosok
      </a>
    </li>
    <li [class.active]="isActiveLink('exam-addresses')" class="nav-item">
      <a (click)="navigateTo('exam-addresses')" class="nav-link text-dark">
        <span class="material-icons">location_on</span>
        Vizsgahelyszínek
      </a>
    </li>
    <li [class.active]="isActiveLink('student-results')" class="nav-item">
      <a (click)="navigateTo('student-results')" class="nav-link text-dark">
        <span class="material-icons">emoji_events</span>
        Eredmények
      </a>
    </li>
  </ul>
</div>
